import { Badge, ActionIcon, Loader } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { CaseFlagApplication } from "../../services/flagDefinitionsService";

interface FlagBadgeProps {
  application: CaseFlagApplication;
  onRemove?: (applicationId: string) => void;
  loading?: boolean;
}

export function FlagBadge({ application, onRemove, loading }: FlagBadgeProps) {
  return (
    <Badge
      color={application.flagDefinition.color}
      variant="light"
      size="sm"
      pr={onRemove ? 3 : undefined}
      rightSection={
        onRemove ? (
          loading ? (
            <Loader size={12} />
          ) : (
            <ActionIcon
              size={16}
              variant="transparent"
              color={application.flagDefinition.color}
              onClick={(e) => {
                e.stopPropagation();
                onRemove(application.id);
              }}
            >
              <IconX size={12} />
            </ActionIcon>
          )
        ) : null
      }
    >
      {application.flagDefinition.name}
    </Badge>
  );
}
